import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable()
export class AnonymousClientAuthGuardService implements CanActivate {
    lang = '';
  constructor(public auth: AuthService, public router: Router) {
    const href = this.router.url;
    this.lang = href.split('/')[1];
    if(this.lang == 'en' || this.lang == 'cn' || this.lang == 'kr'){      
    }
    else {
      this.lang = 'jp';
    }

  }
  canActivate(): boolean {
    if (!this.auth.isCompanyAuthenticated()) {
      return true;
    }
    
    this.router.navigate([(this.lang === 'en' ? '/en/' : '/') + 'client']);
    return false;
  }
}